import { cx } from 'class-variance-authority';
import { forwardRef } from 'react';
import { Box } from '../Box';
import { BaseTypeMap, Component, ComponentProps } from '../types/Component';

type SpinnerTypeMap = BaseTypeMap<
  'svg',
  {
    label: string;
  }
>;

export type SpinnerProps = ComponentProps<SpinnerTypeMap>;

export const Spinner: Component<SpinnerTypeMap> = forwardRef(function Spinner(
  {
    label,
    className,
    fill = 'currentColor',
    width = '1em',
    height = '1em',
    viewBox = '0 0 24 24',
    ...rest
  },
  ref
) {
  return (
    <Box
      as="svg"
      ref={ref}
      className={cx('animate-spin', className)}
      fill={fill}
      width={width}
      height={height}
      viewBox={viewBox}
      aria-label={label}
      role="presentation"
      {...rest}
    >
      <Box
        as="path"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </Box>
  );
});
